<!-- 裁判管理 -->
<template>
    <div>
        <event-head></event-head>
        <div class="mt-5 flex-1">
            <div>
            <el-tabs v-model="activeName" topline>
                <el-tab-pane label="裁判列表" name="first">
                    <referee-list v-if="activeName == 'first'"> </referee-list>
                </el-tab-pane>
                <el-tab-pane label="裁判审核" name="second">
                <referee-examine v-if="activeName == 'second'"></referee-examine>
                </el-tab-pane>
            </el-tabs>
            </div>
        </div>
    </div>
</template>
<script>
import EventHead from '@/common/components/eventHead/EventHead';
import RefereeList from './RefereeList.vue';
import RefereeExamine from './RefereeExamine.vue';
export default {
    components: {
        EventHead,RefereeList,RefereeExamine
    },
    data() {
        return {
            activeName: "first",   
        };
    },
    mounted() {},
    methods: {},
};
</script>
<style lang="scss" scoped>

</style>